import { RulesService } from '@/services/rules.service';
import { RuleNames, RulesServiceStates, RulesServiceTypes, RulesServiceConfig } from '@/services/rules.service.config';

export const validationMixin = {
	data() {
		return {
			validationResults: [],
			validationTypes: {
				duration: [RuleNames.minimumDuration, RuleNames.maxIntervals],
				participants: [RuleNames.adultMinor, RuleNames.participantSelection, RuleNames.ageLimit],
				waiver: [RuleNames.documentAcceptance],
				spot: [RuleNames.spotSelection],
				notifications: RulesServiceConfig.getNotificationErrors()
			},
			rules: null,
			specialRequirements: []
		};
	},
	methods: {
		buildRules(data) {
			if (!data.validation) return;
			this.rules = data.validation.rules;

			const extraConditions = RulesService.getExtraConditions(this.rules);
			this.specialRequirements = extraConditions.specialRequirements;
		},

		validateComplete() {
			this.validationResults = RulesService.validateClient(
				this.rules,
				{
					selectedParticipants: this.participantsSelected,
					waiverRequired: this.ux.waiverContent && this.waiverDisplay,
					waiverAccepted: this.waiverAccepted,
					spot: this.spotSelected,
					hasSpots: this.spots.length > 0,
					openSpots: this.ux.openSpots,
					duration: this.duration ? this.duration.value : null,
					startMoment: this.ux.start
				},
				RulesServiceTypes.REGISTRATION,
				RulesServiceStates.PENDING_FINISH,
				[
					RuleNames.authenticated,
					RuleNames.participantSelection
				]
			);
			return this.validationResults.length === 0;
		},

		validateServer(pendingResult) {
			this.validationResults = [];
			if (pendingResult.errors && pendingResult.errors.length) {
				this.validationResults = RulesService.validateServer(this.regType, pendingResult.errors);
			}

			if (this.validationResults.length > 0) {
				if (RulesService.notAuthenticated(this.validationResults)) {
					this.doCancelRedirect('Not authenticated');
					return false;
				}

				this.buildNotificationMessage(true);

				return false;
			}
			return true;
		},

		buildNotificationMessage(fromServer) {
			let message = '';
			for (const err of this.validationResults) {
				if (this.validationTypes.notifications.includes(err.name)) {
					message += err.message + '<br>';
				}
			}
			if (message || fromServer) {
				this.mountServerError(false, message || '');
			}
		}
	}
};
